module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANRW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aufstieg und Niedergang der römischen Welt")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Antiquities of the Jews")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BAGD")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BTB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Theology Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CEV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contemporary English Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NA26")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nestle-Aland "), _c('em', [_vm._v("Greek New Testament,")]), _vm._v(" 26th ed.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nicene and Post-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("par.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("parallel(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Recherches de science religieuse")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("RSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTSMS")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G. Kittel and G. Friedrich, eds., "), _c('em', [_vm._v("Theological Dictionary of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ThZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZTK")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66463035","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0